import * as types from '../actions/actionTypes.js';
import initialState from "./initialState.js";


export function navigationReducer(
  state = initialState.navigation, action
  ) {
  switch(action.type) {
    case types.UPDATE_HAMBURGER_MENU_STATUS:
      return {
        ...state,
        hamburgerMenu: action.status
      }
      case types.UPDATE_THEME:
        return {
          ...state,
          theme: action.theme
        }
    default:
      return state;
  }
}

